import { QueryTarget } from "@/shared/domain/query";

/**
 * Plural noun for the records a target holds.
 *
 * A `Record` keyed by the enum rather than a lookup with a fallback: adding a
 * `QueryTarget` should fail the build here, not ship a Clear button whose
 * tooltip reads "all undefined" on the one table nobody opened before release.
 */
const PLURAL_NOUNS: Record<QueryTarget, string> = {
  [QueryTarget.Collections]: "collections",
  [QueryTarget.Datasets]: "datasets",
  [QueryTarget.Devices]: "devices",
  [QueryTarget.Events]: "events",
  [QueryTarget.Files]: "files",
  [QueryTarget.Sessions]: "sessions",
  [QueryTarget.Topics]: "topics",
  [QueryTarget.TopicMessagePaths]: "message paths",
};

/**
 * What the table shows once its View is cleared, named after what the table
 * holds — "all results" would read the same on every table in the product.
 * Lower case, for the middle of a sentence: "Back to all files".
 */
export function allRecordsLabel(target: QueryTarget): string {
  return `all ${PLURAL_NOUNS[target]}`;
}
